/**
 * Dispatcher para /events/:id según rol.
 * - Miembros ven una vista de solo lectura (MemberEventDetailPage).
 * - Directores y admins ven el panel completo (EventDetailPage).
 */

import { Loader2 } from "lucide-react";
import { usePermissions } from "@/hooks/usePermissions";
import { useAuthStore } from "@/stores/authStore";
import EventDetailPage from "./EventDetailPage";
import MemberEventDetailPage from "./MemberEventDetailPage";

export default function EventDetailRouter() {
  const { role } = usePermissions();
  const loading = useAuthStore((s) => s.loading);

  if (loading || !role) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <Loader2 className="w-8 h-8 animate-spin text-primary-600" />
      </div>
    );
  }

  if (role === "member") {
    return <MemberEventDetailPage />;
  }

  return <EventDetailPage />;
}
